import { render } from "./TheButton.vue?vue&type=template&id=7df48eee"
import script from "./TheButton.vue?vue&type=script&lang=js"
export * from "./TheButton.vue?vue&type=script&lang=js"
script.render = render

export default script